const ResetIcon = () => {
    return (
        <img
            style={{ width: '100%', height: '100%' }}
            src="/images/reset-icon.svg"
            alt="Document Icon"
        />
    );
};

export default ResetIcon;
